import type { iSupplierBillPaymentReceipt } from "@sdk/supplier-bill-payment-receipts/supplier-bill-payment-receipt-model";
import { iStore } from "../../store.model";
import { CreateSelectorForEntities } from "../../utils/entity-slice-creator";

export const {
  selectQueryMap: selectSupplierBillPaymentReceiptQueryMap,
  selectEntityMap: selectSupplierBillPaymentReceiptsMap,
  selectQueryMapAll: selectSupplierBillPaymentReceiptsMapAll,
  selectQueryAllList: selectSupplierBillPaymentReceiptsAllList,
  selectAllEntities: selectAllSupplierBillPaymentReceipts,
  selectAllEntitiesQuery: selectAllSupplierBillPaymentReceiptsQuery,
  selectEntityById: selectSupplierBillPaymentReceiptById,
  selectEntityQuery: selectSupplierBillPaymentReceiptQuery,
  selectEntityQueryList: selectSupplierBillPaymentReceiptQueryList,
} = CreateSelectorForEntities<iStore, iSupplierBillPaymentReceipt>({
  sliceName: "supplierBillPaymentReceipts",
});

export const selectSupplierBillPaymentReceiptsByBillId =
  (supplierBillId: string) =>
  (state: iStore): iSupplierBillPaymentReceipt[] => {
    if (!supplierBillId) return [];
    const byIds = state.supplierBillPaymentReceipts?.byIds ?? {};
    const receiptIds = state.supplierBillPaymentReceipts?.queries
      ? Object.values(state.supplierBillPaymentReceipts.queries).flatMap(
          (q) => q?.list ?? []
        )
      : [];
    const seen = new Set<string>();
    return receiptIds
      .map((id) => byIds[id])
      .filter((r): r is iSupplierBillPaymentReceipt => {
        if (!r?.id || seen.has(r.id)) return false;
        seen.add(r.id);
        return r.supplierBillId === supplierBillId;
      });
  };
